import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { DVHero } from '../components/diva/DVHero';
import { DVWhatIs } from '../components/diva/DVWhatIs';
import { DVDivaTyte } from '../components/diva/DVDivaTyte';
import { DVBenefits } from '../components/diva/DVBenefits';
import { DVHowItWorks } from '../components/diva/DVHowItWorks';
import { DVFAQ } from '../components/diva/DVFAQ';
import { DVWhyChoose } from '../components/diva/DVWhyChoose';
export function VaginalRejuvenationPage() {
  return <div className="min-h-screen w-full bg-black font-body" style={{
    scrollBehavior: 'smooth'
  }} data-id="element-2665">
      <Navigation data-id="element-2666" />
      <main data-id="element-2667">
        <DVHero data-id="element-2668" />
        <DVWhatIs data-id="element-2669" />
        <DVDivaTyte data-id="element-2670" />
        <DVBenefits data-id="element-2671" />
        <DVHowItWorks data-id="element-2672" />
        <DVFAQ data-id="element-2673" />
        <DVWhyChoose data-id="element-2674" />
      </main>
      <Footer data-id="element-2675" />
    </div>;
}